<template>
<div>
    <div class="md-layout rows-relatorio">
        <div v-if="permissoes.rhComprasAnaliticoRead || permissoes.rhFuncionarioRead || permissoes.rhComprasSinteticoRead"
        class="md-layout-item md-size-100 md-xsmall-size-100">
            <strong class="text-relatorio text-site">RH</strong>
        </div>

        <div v-if="permissoes.rhComprasAnaliticoRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-site" :to="{name:'rhComprasAnaliticoRead'}">
                <i class="fas fa-credit-card icon-relatorio text-info"></i>
                <strong class="text-relatorio">COMPRAS ANALÍTICO</strong>
            </router-link>
        </div>

        <div v-if="permissoes.rhComprasSinteticoRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-site" :to="{name:'rhComprasSinteticoRead'}">
                <i class="fas fa-credit-card icon-relatorio text-info"></i>
                <strong class="text-relatorio">COMPRAS SINTÉTICO</strong>
            </router-link>
        </div>

        <div v-if="permissoes.rhFuncionarioRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-site" :to="{name:'rhFuncionarioRead'}">
                <i class="fas fa-users icon-relatorio text-info"></i>
                <strong class="text-relatorio">FUNCIONÁRIOS</strong>
            </router-link>
        </div>

        <div v-if="permissoes.fornecedoresRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-site" :to="{name:'fornecedoresRead'}">
                <i class="fas fa-store-alt icon-relatorio text-info"></i>
                <strong class="text-relatorio">REDE CREDENCIADA</strong>
            </router-link>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            permissoes: this.$store.state.usuario.permissao
        }
    }
};
</script>
